function buildHashtagFormData(
	data: Partial<AdminHashtag>,
	imageFile: File | null,
	imageRemoved: boolean
): FormData {
	const formData = new FormData();
	formData.append("name", data.name ?? "");
	formData.append("color", data.color ?? "");
	formData.append("description", data.description ?? "");
	formData.append("is_private", String(data.isPrivate ?? false));
	formData.append("is_favourite", String(data.isFavourite ?? false));
	formData.append(
		"exclude_from_main_feed",
		String(data.excludeFromMainFeed ?? false)
	);

	if (imageFile) {
		formData.append("image", imageFile);
	} else if (imageRemoved) {
		formData.append("image", "");
	}

	return formData;
}

export const adaptCreateHashtagPayload = (
	data: Partial<AdminHashtag>,
	imageFile: File | null
): FormData => {
	return buildHashtagFormData(data, imageFile, false);
};

export const adaptEditHashtagPayload = (
	data: Partial<AdminHashtag>,
	imageFile: File | null,
	imageRemoved = false
): FormData => {
	return buildHashtagFormData(data, imageFile, imageRemoved);
};
